import Feature from "src/js/stores/user/Feature";
import { SitesLayerType } from "../layer_types/SitesLayerType";
import { Layer, LayerGroup } from "../types";

export const SITES_LAYER_ID = "sites";

export const SITES_LAYER: Layer = {
  id: SITES_LAYER_ID,
  layerType: SitesLayerType,
  title: "Saved sites",
  collapsed: true,
  toggleable: true,
  group: LayerGroup.GENERAL,
  icon: "lt-bookmark-line",
  description: "Sites saved by you and your team",
  requiredFeatureAccess: [Feature.sitesLayer],
};
